/* eslint-disable no-console */
/* eslint-disable max-len */
/*
This file contains app type constants. use UPPER_CASE_SNAKE_CASE for constant name.
*/
const VERSION = 'master';
export const HOST_URL = process.env.PUBLIC_URL;
export const STATIC_SERVER_URL = `${process.env.REACT_APP_STATIC_SERVER_URL}`;
export const VIEWPOINT_SERVICE_ENDPOINT = `${process.env.REACT_APP_VIEWPOINT_SERVICE_URL}`;
export const VIEWPOINT_SERVICE_ENDPOINT_GUEST = process.env.REACT_APP_GUEST_ACCESS_RATE_LIMIT_URL
  ? `${process.env.REACT_APP_GUEST_ACCESS_RATE_LIMIT_URL}`
  : VIEWPOINT_SERVICE_ENDPOINT;
export const TRANSLATE_FILE_PATH = `${HOST_URL}/locales/{{lng}}/{{ns}}.json`;
export const MFA_CONFIG_ENTITLEMENT_SERVICE_API = `${VIEWPOINT_SERVICE_ENDPOINT}/entitlements`;
export const THIRD_PARTY_ENTITLEMENT_SERVICE_API = `${process.env.REACT_APP_APP_ENTITLEMENT_SERVICE_URL}/v1/entitled-thirdparty-apps`;
export const APP_DETAILS_SERVICE_API = `${VIEWPOINT_SERVICE_ENDPOINT}/apps`;
export const USER_PROFILE_SERVICE_API = `${VIEWPOINT_SERVICE_ENDPOINT}/user-profile`;
export const GET_COUNTRIES_LIST_API = `${VIEWPOINT_SERVICE_ENDPOINT}/countries-enabled`;
export const MFA_CONFIG_PATH = 'mfa.json';
export const MFA_ENDPOINT_FILE_PATH = 'asset-manifest.json';
export const ENABLE_PENDO = `${process.env.REACT_APP_ENABLE_PENDO}`;
export const POLL_UNREAD_NOTIFS_COUNT_ENDPOINT = `${process.env.REACT_APP_NOTIFICATION_TRANSPORT_SERVICE_URL}/events/notificationCenter/count`;
export const UPDATE_MSG_ARCHIVE_ENDPOINT = `${process.env.REACT_APP_NOTIFICATION_TRANSPORT_SERVICE_URL}/events/notificationCenter/messages/`;
export const GET_MESSAGES_ENDPOINT = `${process.env.REACT_APP_NOTIFICATION_TRANSPORT_SERVICE_URL}/events/notificationCenter/messages`;
export const MARK_MSGS_READ_ENDPOINT = `${process.env.REACT_APP_NOTIFICATION_TRANSPORT_SERVICE_URL}/events/notificationCenter/messages`;
export const PUSH_NOTIFS_URL = `${process.env.REACT_APP_NOTIFICATION_SERVICE_URL}`;
export const IS_PUSH_NOTIFS_ENABLED = `${process.env.REACT_APP_ENABLE_PUSH_NOTIFICATIONS_FLAG}`;
export const IS_NOTIFS_TRANSPORT_SERVICE_ENABLED = `${process.env.REACT_APP_ENABLE_NOTIFICATIONS_TRANSPORT_SERVICE_FLAG}`;
export const NOTIFS_POLL_DELAY_TIME = `${process.env.REACT_APP_POLLING_DELAY_TIME}`;
export const LAUNCH_DARKLY_CLIENT_ID = `${process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID}`;
export const CREATE_USER_IN_AMP_ENDPOINT = `${process.env.REACT_APP_ACCOUNT_MANAGEMENT_SERVICE_URL}/v1/okta/users/`;
export const GET_USER_ONBOARD_STATUS_ENDPOINT = `${process.env.REACT_APP_ACCOUNT_MANAGEMENT_SERVICE_URL}/v1/users/onboard/status`;
export const VIEWPOINT_URL = `${process.env.REACT_APP_VIEWPOINT_URL}`;
export const MY_EAGLEVIEW_URL = `${process.env.REACT_APP_MY_EAGLEVIEW_URL}`;
export const UPDATE_USER_ONBOARD_STATUS_API = `${VIEWPOINT_SERVICE_ENDPOINT}/users/status/complete`;
export const ACCOUNT_ONBOARDING_ACTIVATE_URL = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_URL}/activated`;
export const SIGNUP_URL = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_URL}`;
export const PENDO_APPLICATION_NAME = 'viewpoint';
export const EXPIRE_GUID_API = `${process.env.REACT_APP_ACCOUNT_MANAGEMENT_SERVICE_URL}/v1/users/logout/$guid$`;
export const VALIDATE_USER_IMPERSONATION_API = `${process.env.REACT_APP_ACCOUNT_MANAGEMENT_SERVICE_URL}/v1/users/impersonate`;
export const GUEST_USER_PROFILE_API = `${process.env.REACT_APP_ACCOUNT_MANAGEMENT_SERVICE_URL}/v2/user-profile`;

export const VALIDATE_RESOURCE_PATH_API = `${VIEWPOINT_SERVICE_ENDPOINT_GUEST}/share/apps`;
export const GUEST_ACCESS_SERVICE_URL = `${process.env.REACT_APP_GUEST_ACCESS_SERVICE_URL}`;
export const GUEST_ACCESS_RATE_LIMIT_URL = `${process.env.REACT_APP_GUEST_ACCESS_RATE_LIMIT_URL}`;

export const GUEST_EMAIL_VERIFICATION_API = `${GUEST_ACCESS_RATE_LIMIT_URL}/share/email-verifications`;
export const GUEST_POLL_EMAIL_VERIFICATION_API = `${GUEST_ACCESS_SERVICE_URL}/share/email-verifications`;
export const VERIFY_GUEST_EMAIL_TOKEN_API = `${GUEST_ACCESS_SERVICE_URL}/share/email-verifications/verify`;
export const CHECK_EV_USER_API = `${GUEST_ACCESS_RATE_LIMIT_URL}/share/resource-share`;
export const GUEST_RESOURCE_ACCESS_API = `${GUEST_ACCESS_SERVICE_URL}/share/apps`;
export const RESOURCE_ACCESS_AUDIT_API = `${GUEST_ACCESS_SERVICE_URL}/share/resource-access-audit`;
export const ESRI_PKCE_TOKEN_KEY = 'ESRI_PKCE_TOKEN';

/**
 * fetch-intercept related constants
 */
export const INTERCEPTOR_IGNORE_FILE_EXT = ['json', 'img', 'ttf'];

/**
 * OKTA related constatnts
 */
export const OKTA_CLIENT_ID = `${process.env.REACT_APP_OKTA_CLIENT_ID}`;
export const OKTA_LOGIN_URL = `${process.env.REACT_APP_OKTA_URL}?client_id=${OKTA_CLIENT_ID}&response_type=code&scope=openid offline_access&is3legged=false&signup=true`;
export const OKTA_LOGOUT_URL = `${process.env.REACT_APP_OKTA_URL.substring(0, process.env.REACT_APP_OKTA_URL.lastIndexOf('/'))}/logout`;
export const AUTH_SERVICE_ENDPOINT = `${process.env.REACT_APP_AUTH_SERVICE_URL}/v1`;
export const AUTH_ACCESS_TOKEN_API = `${AUTH_SERVICE_ENDPOINT}/token`;
export const REVOKE_ACCESS_TOKEN_API = `${AUTH_SERVICE_ENDPOINT}/revokeToken`;
// #genai auth-service OAuth2 login endpoint used to hand off to EVONE (Horizon) via redirectURI + clientID
export const AUTH_OAUTH2_LOGIN_API = `${AUTH_SERVICE_ENDPOINT}/oauth2/login`;

// Validation regex
export const STRING_VALIDATION_REGEX = /^[a-zA-Z ]+$/;
export const NUMBER_VALIDATION_REGEX = /^\d+$/;

// server side error codes for User Details fields
export const USER_PROFILE_ERROR_CODES = {
  firstName: [40240, 40241, 40242],
  lastName: [40243, 40244, 40245],
  phoneNumber: [40249, 40250, 40251],
  countryId: [40278, 40282, 40283, 40284, 40285, 40286, 40287, 40288],
};

// Initial error messages for user profile dialog.
export const InitProfileErrorMessages = {
  firstName: '',
  lastName: '',
  title: '',
  phoneNumber: '',
  countryId: '',
};

// List of keys set by the app in browser storage
export const LOCAL_STORAGE_ITEMS = ['token', 'ev_ud', 'ev_mgc', 'ev_pre_access_token'];
export const SESSION_STORAGE_ITEMS = ['token', 'ev_ud'];

// Dedicated localStorage key for the short-lived guest pre-access token.
// Stored separately from 'token' so the Okta / custom-auth token is never overwritten.
// Included in LOCAL_STORAGE_ITEMS above so it is cleared on every logout.
// #genai
export const PRE_ACCESS_TOKEN_KEY = 'ev_pre_access_token';

// sessionStorage key used to hand the GuestAccess context from SharedStartupGate
// to the /signin page across the full-browser-navigation boundary.
// Read-once: consumed and removed by ConfigureStore at store initialisation so
// every component sees the correct state on the very first render.
export const GUEST_CONTEXT_SESSION_KEY = 'ev_guest_ctx';

// sessionStorage key for the loginId returned by checkIsEvUser.
// Written before Okta redirect, consumed once by SharedStartupGate to fire the
// user-access-audit call, then removed so a page refresh doesn't re-trigger it.
export const SHARED_LOGIN_ID_KEY = 'ev_shared_login_id';

// Interval at which the check to replace the token happens
export const REFRESH_CHECK_INTERVAL = 5000;

// New token retry delay seconds
export const RETRY_DELAY = {
  1: 1000, // 1st retry after 1sec
  2: 2000, // 2nd retry after 2sec
  3: 4000, // 3rd retry after 4sec
};

// Notification types
export const NOTIFICATION_TYPE = {
  WebPush: 'WEB_PUSH',
  Mail: 'MAIL',
  Text: 'TEXT',
};

export const AppNameList = {
  myeagleview: 'My Eagleview',
  apicenter: 'Eagleview Developer',
  viewpoint: 'EV Cloud',
};

/** Third-party entitled app code for Eagleview One (EVONE). #genai */
export const EVONE_APP_CODE = 'EVONE';
/** Entitlement ingredient required to redirect to EVONE from user entitled apps. #genai */
export const EVONE_ACCESS_INGREDIENT = 'EVONE_ACCESS';
/** OAuth2 client ID used when handing the user off to EVONE through auth-service /oauth2/login. #genai */
export const EVONE_CLIENT_ID = `${process.env.REACT_APP_EVONE_CLIENT_ID || ''}`;

export const VP_NAVBAR_FULLSCREEN = 'VpNavbarFullscreen';
export const REDIRECTING_TO_LOGIN = 'RedirectingToLogin';
export const JS_ERROR = 'jserror';

export const EV_SUPPORT_LINK = 'https://www.eagleview.com/support';

export const MAX_POLL_TIME = 60000;
export const POLL_DURATION = 5000;

export const EVENTS = {
  FULL_SCREEN: 'FULL_SCREEN',
};

// wait in milliseconds
export const WAIT_AFTER_REVOKE_TOKEN_API_CALL = 500;

export const FULL_SCREEN_PATHS = ['/accounts/download'];

export const INITIATE_USER_IMPERSONATION_EVENT = 'initiateUserImpersonation';
export const SIGN_IN_AS_GUID = 'signInAsGuid';
export const USER_IMPERSONATION_ERROR = 'UserImpersonationError';
export const USER_IMPERSONATION_UNAUTHORISED_ERROR = 'UserImpersonationUnauthorizedError';
export const GET_CUSTOM_TOKEN_ERROR = 'GetCustomTokenError';
export const TRANSLATION_ERROR_LIST = [
  REDIRECTING_TO_LOGIN,
  USER_IMPERSONATION_ERROR,
  USER_IMPERSONATION_UNAUTHORISED_ERROR,
  GET_CUSTOM_TOKEN_ERROR,
];
export const USER_IMPERSONATION_BROADCAST_TYPE = 'user_impersonation_session_change';
export const BANNER_POSITION = 'bannerPosition';

export const LOGO_TYPE = {
  LOGO_WITH_TEXT: 'logoWithText',
  LOGO_WITH_TEXT_STACKED: 'logoWithTextStacked',
  LOGO: 'logo',
};

export const TRUE_DESIGN_APP_ID = 'truedesign';
export const PROPERTY_VIEWER_APP_ID = 'property';
export const HIDDEN_APPS = [
  TRUE_DESIGN_APP_ID,
  PROPERTY_VIEWER_APP_ID,
];

export const EV_LOADER_IMAGE_PATH = `${process.env.REACT_APP_IMAGE_PATH_URL}/evimages/EVLoader.gif`;

export { default as DEFAULT_BG_IMAGE_URL } from '../assets/OktaCoverImage.jpeg';
export { default as DEFAULT_LOGO_URL } from '../assets/EagleViewLogoWithText.svg';
export const TERMS_OF_USE_LINK = 'https://www.eagleview.com/terms/';
export const PRIVACY_POLICY_LINK = 'https://www.eagleview.com/privacy-statement/';

console.log('Viewpoint Version: ', VERSION);
